import React from 'react';
import PropTypes from 'prop-types';

const Wrapper = ({ children, ...restProps }) => (
  <div
    {...restProps}
    style={{
      margin: '2em auto',
      width: 40,
      height: 40,
      position: 'relative',
    }}
  >
    {children}
  </div>
);

Wrapper.propTypes = {
  children: PropTypes.any,
};

export default Wrapper;
